import React, { useEffect } from 'react';
import { FormLabel, Grid, Divider, Collapse } from '@material-ui/core';
import { Controller, useFormContext, useFieldArray } from 'react-hook-form';
import { useTranslate } from 'hooks/use-translate';
import { useFieldProps } from 'hooks';
import { AppInput } from 'components/app-input';
import { AppSelect } from 'components/app-select';
import { useSourceWhatsAppTemplates } from 'hooks/use-source-whats-app-templates';
import { FormModel } from '../../models';
import { ServiceWhatsAppContents } from 'services/whats-app-contents';
import style from './index.module.scss';
interface Props {
  isLoading: boolean;
  templatesPayload: Record<string, any>;
}

export const Form: React.FC<Props> = ({ isLoading, templatesPayload }) => {
  const { t } = useTranslate();

  const sourceTemplates = useSourceWhatsAppTemplates();

  const { errors, control, watch, setValue } = useFormContext<FormModel>();

  const getFieldProps = useFieldProps({ errors, emptyHelperText: '' });

  const { fields } = useFieldArray({
    control,
    name: 'variables',
  });

  const templateID = watch('whatsAppContentID');

  const template = React.useMemo(
    () => sourceTemplates.data.find((t) => t.id === templateID),
    [sourceTemplates.data, templateID],
  );

  useEffect(() => {
    if (!template) return;

    const variables = ServiceWhatsAppContents.makeVariables(template.variables, templatesPayload);

    setValue('variables', variables);
  }, [template, setValue, templatesPayload]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            control={control}
            name={'toPhoneNumber'}
            render={(renderProps) => (
              <AppInput
                {...getFieldProps(renderProps)}
                label={t('mobile-phone')}
                disabled={isLoading}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name={'whatsAppContentID'}
            render={(renderProps) => {
              return (
                <AppSelect
                  {...getFieldProps(renderProps)}
                  disabled={isLoading}
                  disableClearable
                  options={sourceTemplates.data}
                  loading={sourceTemplates.loading}
                />
              );
            }}
          />
        </Grid>
      </Grid>
      <Collapse in={fields.length > 0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Divider className={style.divider} />
          </Grid>
          <Grid item xs={12}>
            <div style={{ paddingBottom: '10px' }}>
              <FormLabel>{t('variables')}</FormLabel>
            </div>
          </Grid>
          {fields.map((field, index) => {
            return (
              <Grid item xs={12} key={field.id}>
                <Controller
                  control={control}
                  name={`variables[${index}].value`}
                  defaultValue={field.value}
                  render={(renderProps) => {
                    const props = getFieldProps(renderProps, { withLabel: false });

                    return (
                      <AppInput
                        {...props}
                        label={field.title}
                        variant={'outlined'}
                        size={'small'}
                      />
                    );
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Collapse>
    </>
  );
};
